import Auth from "@/auth.js";
import Swal from "sweetalert2";
import { get } from "lodash";
export default {
  namespaced: true,
  state: {
    secondStepVerificationEnabled: true,
    error: null,
    token: Auth.token.get(),
    verified: Auth.verify.get(),
    user: Auth.user.get(),
    authenticating: false,
    authenticated: Auth.authenticated(),
    iframeSrc: "",
    keepLogin: "",
    sendingResetEmail: false,
    resettingPassword: false,
  },
  mutations: {
    SET_TOKEN: (state) => {
      state.token = Auth.token.get();
    },
    SET_VERIFIED: (state) => {
      state.verify = Auth.verify.get();
    },
    SET_ERROR: (state, error) => {
      state.error = error;
    },
    SET_AUTHENTICATED: (state, bool) => {
      state.authenticated = bool;
    },
    SET_IFRAME_SRC: (state, string) => {
      state.iframeSrc = string;
    },
    SET_KEEP_LOGIN: (state, string) => {
      state.keepLogin = string;
    },
    SET_AUTHENTICATING: (state, bool) => {
      state.authenticating = bool;
    },
    SEND_RESET_PASSWORD: (state, bool) => {
      state.sendingResetEmail = bool;
    },
    RESETTING_PASSWORD: (state, bool) => {
      state.resettingPassword = bool;
    },
  },
  actions: {
    login: ({ commit, dispatch }, payload) => {
      return new Promise(function (resolve) {
        Auth.login(payload.user, payload.password)
          .then((accessToken) => {
            Auth.getUser(accessToken)
              .then(function (res) {
                commit("SET_AUTHENTICATING", false);
                if (res.active) {
                  commit("SET_TOKEN", accessToken);
                  return resolve(res);
                } else {
                  dispatch(
                    "setError",
                    {
                      message: "Your account has been deactivated",
                      title: "Error ",
                    },
                    { root: true }
                  );
                  return resolve(false);
                }
              })
              .catch((e) => {
                //eslint-disable-next-line
                console.log(e);
                commit("SET_AUTHENTICATING", false);
                commit("SET_AUTHENTICATED", false);
                Auth.revoke();
                return resolve(false);
              });
          })
          .catch((err) => {
            commit("SET_ERROR", err.data);
            commit("SET_AUTHENTICATING", false);
            commit("SET_AUTHENTICATED", false);
            Swal.fire({
              title: "<b class='text-danger'>Sorry</b>",
              html: "<div>There is an issue signing in, if you are sure your email and password are correct, please try again later or contact us via <a href='mailto:support@communitycareconnection.com'>info@communitycareconnection.com</a></div>",
              allowOutsideClick: true,
              allowEscapeKey: true,
              showCloseButton: true,
              focusConfirm: false,
            });
            return resolve(false);
          });
      });
    },
    logout: ({ commit }, payload) => {
      commit("SET_AUTHENTICATING", false);
      commit("SET_AUTHENTICATED", false);
      const noRedirect = get(payload, "noRedirect", false);
      Auth.revoke().then(() => {
        if (!noRedirect) {
          window.location.href = "/login";
        }
      });
    },
    secondStepVerification: function ({ commit, state }, verificationData) {
      commit("SET_AUTHENTICATING", true);
      let vm = this;

      return new Promise(function (resolve, reject) {
        vm.$http
          .post(`verifyMFAToken`, verificationData, {
            headers: {
              Authorization: `Bearer ${state.token}`,
            },
          })
          .then((tokenRes) => {
            if (tokenRes.status == 200) {
              if (tokenRes.data.success) {
                commit("SET_AUTHENTICATED", true);
                resolve(true);
              }
            }
            commit("SET_AUTHENTICATING", false);
            reject(tokenRes.data);
          })
          .catch((err) => {
            commit("SET_AUTHENTICATING", false);
            reject(err);
          });
      });
    },
    forgotPassword: function ({ commit }, data) {
      commit("SEND_RESET_PASSWORD", true);
      let vm = this;
      return new Promise(function (resolve) {
        vm.$http
          .post(`reset-password`, data)
          .then((res) => {
            commit("SEND_RESET_PASSWORD", false);
            if (res.status == 200) {
              return resolve({ success: true });
            }
            return resolve({
              success: false,
              err: { error: "Something went wrong, please try again later." },
            });
          })
          .catch((err) => {
            commit("SEND_RESET_PASSWORD", false);
            return resolve({ success: false, err });
          });
      });
    },
    resetPassword: function ({ commit }, data) {
      commit("RESETTING_PASSWORD", true);
      let vm = this;
      return new Promise(function (resolve) {
        vm.$http
          .post(`reset/password`, data)
          .then((res) => {
            commit("RESETTING_PASSWORD", false);
            if (res.status == 200) {
              return resolve({ success: true });
            }
            return resolve({
              success: false,
              err: { error: "Something went wrong, please try again later." },
            });
          })
          .catch((err) => {
            commit("RESETTING_PASSWORD", false);
            return resolve({ success: false, err });
          });
      });
    },
    setIframeSrc: ({ commit }, payload) => {
      commit("SET_IFRAME_SRC", payload.src);
      commit("SET_KEEP_LOGIN", payload.keepLogin);
    },
  },
};
